<div class="container-fluid finance-wrapper mt-1" *ngIf="marketingD">

  <div class="row g-4">

    <!-- ================= BASIC MARKETING SETTINGS ================= -->
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="finance-card mb-3">
        <div class="finance-header">
          <i class="fas fa-bullhorn"></i>
          Marketing Setup
        </div>

        <hr />

        <div class="row g-3">

          <div class="col-md-3">
            <label for="noServiceCenter">Number of Service Centers</label>
            <input type="number" class="form-control" [(ngModel)]="marketingD.NumberofServiceCenters"
              (change)="onValueChange()" id="noServiceCenter" name="noServiceCenter"/>
          </div>

          <div class="col-md-3">
            <label for="noSaleOutlet">Number of Sales Outlets</label>
            <input type="number" class="form-control" [(ngModel)]="marketingD.NumberofSalesOutlets"
              (change)="onValueChange()" id="noSaleOutlet" name="noSaleOutlet"/>
          </div>

          <div class="col-md-3 d-flex align-items-center">
            <div class="form-check mt-3">
              <input type="checkbox" class="form-check-input" id="marketResearchReport" name="marketResearchReport" [checked]="marketingD.MarketResearch === 'Y'"
                (change)="toggleYN('MarketResearch')" />
              <label class="form-check-label" for="marketResearchReport">
                Buy Market Research Report
              </label>
            </div>
          </div>

          <div class="col-md-3 d-flex align-items-center">
            <div class="form-check mt-3">
              <input type="checkbox" class="form-check-input" [checked]="marketingD.DataOnCompetition === 'Y'"
                (change)="toggleYN('DataOnCompetition')" id="buyCompitionData" name="buyCompitionData"/>
              <label class="form-check-label" for="buyCompitionData">
                Buy Competition Data
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--================= BRAND SPEND TABLE =================-->
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="finance-card sales-marketing-card">
        <div class="finance-header"><i class="fas fa-tags"></i> Sales & Marketing</div>
        <hr />
        <div class="table-responsive marketing-table-wrapper">
          <table class="table align-middle text-center marketing-table table-striped">
            <thead>
              <tr>
                <th>Brand / Product</th>
                <th>Dealer Incentive (%)</th>
                <th>Buy Consumer Insight report (Y/N)</th>
                <th *ngFor="let ch of channels">{{ ch }}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let brand of marketingD.brandPromotion">
                <tr>
                  <td class="fw-semibold">
                    {{ brand.productName }}
                  </td>

                  <td>
                    <ng-container *ngIf="brand.CompanyBrand !== 'Y'; else emptyCell">
                      <input type="number" min="0" max="100" class="form-control form-control-sm"
                        [(ngModel)]="brand.dealerIncentive" (change)="onValueChange()" />
                    </ng-container>
                  </td>

                  <td>
                    <ng-container *ngIf="brand.CompanyBrand !== 'Y'; else emptyCell">
                      <input type="checkbox" class="form-check-input" [checked]="brand.MarketPerceptionReport === 'Y'"
                        (change)="toggleMarketPerceptionYN(brand)" />
                    </ng-container>
                  </td>

                  <td *ngFor="let ch of channels">
                    <div class="d-flex flex-column">
                        <input type="number" class="form-control form-control-sm"
                        name="spend_{{ brand.productId }}_{{ ch }}" [(ngModel)]="brand.spend[ch]"
                        (change)="onSpendChange(brand, ch)" />
                        <small>{{ getSpendWords(brand, ch) }}</small>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>

</div>


<!-- ================= EMPTY CELL TEMPLATE ================= -->
<ng-template #emptyCell>
  <span class="text-muted">—</span>
</ng-template>